/*
    Содержит информацию по данным ПГИ у скважин
*/
export const pgiWellModel = {
    name: 'pgiWell',
    state: {
        pgi: {},
    },
    reducers: {
        setPGIByID(state, payload) {
            const { wellID, data } = payload;

            if (wellID in state.pgi) return state;

            return { ...state, pgi: { ...state.pgi, [wellID]: data } };
        },
    },
    effects: () => ({
        setPGIEffect(payload) {
            this.setPGIByID(payload);
        },
    }),
};
